// extracted by mini-css-extract-plugin
module.exports = {"Form":"ReferralLinkRequest_Form__2WXWV"};